import type { WishListItemCardViewModel } from 'tradera/state/services/types/webapi-member-generated';
import { localStore } from 'tradera/utils/storage';
import { STORAGE_KEYS, STORAGE_VALUES } from 'tradera/constants/storage';
import GdprSettings from 'tradera/utils/gdpr-settings';

export const shouldShowShareWishlistTooltip = () =>
    localStore &&
    localStore.getItem(STORAGE_KEYS.SHARE_WISHLIST_TOOLTIP) !==
        STORAGE_VALUES.SHARE_WISHLIST_TOOLTIP_CLICKED &&
    GdprSettings.isFunctionalEnabled();

export const hideShareWishlistTooltip = () =>
    localStore &&
    localStore.setItem(
        STORAGE_KEYS.SHARE_WISHLIST_TOOLTIP,
        STORAGE_VALUES.SHARE_WISHLIST_TOOLTIP_CLICKED,
    );

export const shouldShowShareWishlistSantaTooltip = () =>
    localStore &&
    localStore.getItem(STORAGE_KEYS.SHARE_WISHLIST_TOOLTIP_SANTA) !==
        STORAGE_VALUES.SHARE_WISHLIST_TOOLTIP_SANTA_CLICKED &&
    GdprSettings.isFunctionalEnabled();

export const hideShareWishlistSantaTooltip = () =>
    localStore &&
    localStore.setItem(
        STORAGE_KEYS.SHARE_WISHLIST_TOOLTIP_SANTA,
        STORAGE_VALUES.SHARE_WISHLIST_TOOLTIP_SANTA_CLICKED,
    );

export const buildShareObject = (
    selectedItems: Array<WishListItemCardViewModel>,
    text: string,
) => {
    const urlString = selectedItems
        .map((item) => `${location.origin}${item.itemUrl}`)
        .join('\n \n');

    const shareText = text + '\n \n' + urlString;

    return shareText;
};
